// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  messageId: __t.u64().primaryKey().name("message_id"),
  conversationId: __t.u64().name("conversation_id"),
  senderIdentity: __t.identity().name("sender_identity"),
  content: __t.string(),
  messageType: __t.string().name("message_type"),
  replyToMessageId: __t.option(__t.u64()).name("reply_to_message_id"),
  threadRootId: __t.option(__t.u64()).name("thread_root_id"),
  sentAt: __t.timestamp().name("sent_at"),
  editedAt: __t.option(__t.timestamp()).name("edited_at"),
  isDeleted: __t.bool().name("is_deleted"),
  isPinned: __t.bool().name("is_pinned"),
  metadata: __t.option(__t.string()),
});
